<template>
  <header>
    <div class="nav-bar">
      <figure class="logo">
        <i>
          <svg
              height="40px"
              viewBox="0 0 249 249"
              version="1.1"
              xmlns="http://www.w3.org/2000/svg"
              xmlns:xlink="http://www.w3.org/1999/xlink"
          >
            <g
                id="Page-1"
                stroke="none"
                stroke-width="1"
                fill="none"
                fill-rule="evenodd"
            >
              <circle
                  id="Oval"
                  stroke="#FFFFFF"
                  stroke-width="10"
                  cx="124.5"
                  cy="124.5"
                  r="119.5"
              ></circle>
              <circle
                  id="Oval"
                  fill="#FFFFFF"
                  cx="124.5"
                  cy="126.5"
                  r="16.5"
              ></circle>
              <circle
                  id="Oval"
                  stroke="#FFFFFF"
                  stroke-width="11"
                  cx="151.5"
                  cy="124.5"
                  r="57.5"
              ></circle>
            </g>
          </svg>
        </i>
      </figure>
      <NavigationComponent/>
    </div>
  </header>
</template>

<script>
  import NavigationComponent from "./NavigationComponent.vue";
  export default {
    name: 'HeaderComponent',
    components: {NavigationComponent},
  };
</script>

<style lang="scss">
  $primary-color: #263f7a;
  $border-color: #545454;

  @media only screen and (min-width: 0px) {
    header {
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      z-index: 1000;

      .nav-bar {
        background-color: $primary-color;
        padding: 10px 20px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        border-bottom: 1px solid $border-color;
      }

      .logo {
        height: 40px;
        display: flex;
        align-items: center;
        margin: 0;

        svg {
          height: 100%;
        }
      }

      @media only screen and (min-width: 768px) {
        .nav-bar {
          padding: 10px 40px;
        }
      }
    }
  }

</style>